import React, { useState } from "react";
import { useNavigate, NavLink } from "react-router-dom";
import { Row, Card, CardTitle, Label, FormGroup, Button } from "reactstrap";
import axios from "axiosClient";
import { Formik, Form, Field } from "formik";

import { Colxx } from "../components/common/CustomBootstrap";
import UserLayout from "layout/UserLayout";
import { useToken } from "auth/useToken";
import { useTranslation } from "react-i18next";
import LanguageDropdown from "components/LanguageDropdown";

const ForgotPassword = ({ loading }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [email, setEmail] = useState("");
  const [success, setSuccess] = useState(false);

  const [errors, setErrors] = useState({
    email: "",
    date: "",
    server: "",
  });

  const onUserLogin = async (e) => {
    e.preventDefault();
    if (!loading) {
      if (email === "") {
        setErrors({ ...errors, username: t("enterEmail") });
      } else if (email !== "") {
        try {
          const response = await axios.post("/api/forgot-password", {
            email,
          });
          if (response.status === 200) setSuccess(true);
          else setErrors({ ...errors, server: t("smthWentWrong") });
        } catch (error) {
          // console.log(error.response);
          setErrors({ ...errors, server: error.response.data });
        }
      }
    }
  };

  return (
    <UserLayout>
      <Row className="h-100">
        <Colxx xxs="12" md="10" className="mx-auto my-auto">
          <Card className="auth-card">
            <div className="position-relative image-side ">
              <p className="text-white h2">Mock TKT</p>
              <p className="white mb-0">{t("forgotPasswordText")}</p>
            </div>
            <div className="form-side">
              <div className="d-flex align-items-center justify-content-between">
                <div></div>
                <LanguageDropdown />
              </div>
              <CardTitle className="mb-4">{t("forgotPassword")}</CardTitle>

              {success ? (
                <p className="text-success">{t("checkYourEmail")}</p>
              ) : (
                <Formik>
                  {() => (
                    <Form
                      className="av-tooltip tooltip-label-bottom"
                      onSubmit={onUserLogin}
                    >
                      <FormGroup className="form-group has-float-label">
                        <Label>{t("email")}</Label>
                        <Field
                          className="form-control"
                          name="email"
                          value={email}
                          onChange={(e) => {
                            setEmail(e.target.value);
                            setErrors({ ...errors, server: "", email: "" });
                          }}
                        />
                        {errors.email !== "" && (
                          <div className="invalid-feedback d-block">
                            {errors.email}
                          </div>
                        )}
                      </FormGroup>
                      <p className="text-danger">{errors.server}</p>
                      <div className="d-flex justify-content-between align-items-center">
                        <NavLink to="/register">{t("notRegistered")}</NavLink>

                        <Button
                          type="submit"
                          color="primary"
                          className={`btn-shadow btn-multiple-state ${
                            loading ? "show-spinner" : ""
                          }`}
                          size="lg"
                        >
                          <span className="spinner d-inline-block">
                            <span className="bounce1" />
                            <span className="bounce2" />
                            <span className="bounce3" />
                          </span>
                          <span className="label">{t("submit")}</span>
                        </Button>
                      </div>
                    </Form>
                  )}
                </Formik>
              )}
            </div>
          </Card>
        </Colxx>
      </Row>
    </UserLayout>
  );
};

export default ForgotPassword;
